import { MemberDTO } from "../../services/apiClient";
import { convertToUserTime } from "../../utils/dateUtils/convertToUserTime";

interface MemberDetailsProps {
    member: MemberDTO
}

const MemberDetails: React.FC<MemberDetailsProps> = ({member}) => {
  return (
    <div className="flex justify-around col-span-full">
      <div className="flex flex-col gap-2">
        <div>
          <span>Name</span>
        </div>
        <div>
          <span>{member?.firstName}</span>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div>
          <span>Surname</span>
        </div>
        <div>
          <span>{member?.lastName}</span>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div>
          <span>Id Number</span>
        </div>
        <div>
          <span>{member?.idPassportNumber}</span>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div>
          <span>FCA Status</span>
        </div>
        <div>
          <span>{member?.memberCategory?.title}</span>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div>
          <span>Membership</span>
        </div>
        <div>
          <span>{member?.memberType?.title}</span>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <div>
          <span>Paid-up date</span>
        </div>
        <div>
          <span>{convertToUserTime(member?.paidUpTo?.toString() ?? '', true)}</span>
        </div>
      </div>
    </div>
  );
};

export default MemberDetails;
